import { Component, ViewChild, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Store } from '@ngxs/store';
import { Deal } from 'app/models/dto/deal.model';
import { Offer } from 'app/services/offers/offer.model';
import { Approval } from 'app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { PatchOfferOptionStatus } from 'ng2-app/store/offers/offer-options.actions';
import { OffersService } from 'app/services/offers/offers.service';

@Component({
  selector: 'offer-option-more-menu',
  templateUrl: './offer-option-more-menu.component.html',
  styleUrls: ['./offer-option-more-menu.component.scss']
})
export class OfferOptionMoreMenuComponent implements OnInit {

    @Input() option: OfferOption;
    @Input() optionType: string;
    @Input() optionParentName: string;

    @Output() offerOptionUpdated = new EventEmitter<object>();

    canCreateContractRequest: boolean;

    @ViewChild('offerOptionEditModal') private offerOptionEditModal: any;
    @ViewChild('offerOptionDeleteModal') private offerOptionDeleteModal: any;

    constructor(
      private store: Store,
      private offersService: OffersService,
    ) { }

    async ngOnInit() {
      this.canCreateContractRequest = true;

      const invalidStagesForCRCreate = ['application','funded','inactive'];
      const invalidStatusesForCRCreate = ['awaitingResponse','declined'];

      this.canCreateContractRequest = !((invalidStagesForCRCreate.some(stage => stage === this.option.deal?.stage)) ||
         (invalidStatusesForCRCreate.some(status => status === this.option.deal?.status)) || 
         !!this.option.deal?.['contract_request']
         );
    }

    /**
     * Send OfferOption data over to the Contract Request component for submission
     */
    requestContract() {
      this.offersService.setCurrentOfferOption(this.option);
    }

    changeStatus(status) {
      this.store.dispatch( new PatchOfferOptionStatus(this.option.dealId, this.option.id, status) );
    }

    openEditModal() {
      this.offerOptionEditModal.openModal(this.optionType, (this.option.approval || this.option.offer));
    }

    handleOfferOptionUpdated(updatedOfferData){
      this.offerOptionUpdated.emit(updatedOfferData);
      this.option.termSet.term = updatedOfferData.term;
      this.option.termSet.paymentFrequency = updatedOfferData.paymentFrequency;
      this.option.termSet.points = updatedOfferData.points;
      this.option.termSet.amount = updatedOfferData.amount;
      this.option.termSet.originationFeePercent = updatedOfferData.originationPercent;
      this.option.termSet.factorRate = updatedOfferData.factorRate;
      this.option.termSet.paymentCount = updatedOfferData.paymentCount;
      this.option.termSet.paymentAmount = updatedOfferData.paymentAmount;
      this.option.termSet.payback = updatedOfferData.payback;
      this.option.termSet.originationFeeAmount = updatedOfferData.originationAmount;
      this.option.termSet.disbursement = updatedOfferData.disbursement;
      this.option.termSet.commission = updatedOfferData.commission;
    }

    openDeleteConfirmationModal() {
      this.offerOptionDeleteModal.openModal();   
    }

    getOptionParent(option: OfferOption) {
      if(this.optionType === 'approval'){
        return option.approval;
      }
      if(this.optionType === 'offer'){
        return option.offer;
      }
      return [];
    }
}
